import { API } from '@xbto/api-client';
import {
  EnrichedAccountStatement,
  EnrichedGroupedAccountStatement,
} from '../../types';
import { formatStatementPeriodName } from '../format-statement';

function computePdfName(item: API.AccountStatement, period: string | null) {
  const fallbackName = (
    item.fileName ||
    item.accountLabel ||
    'statement'
  ).replace('.pdf', '');
  const suffix = period ? period.replace(' ', '-') : Date.now();
  return `${fallbackName}-${suffix}`;
}

export function enrichAccountStatement(
  item: API.AccountStatement
): EnrichedAccountStatement {
  const labelExtra =
    (item.accountType === API.AccountType.Fund &&
      item.currency?.name &&
      ` / ${item.currency.name}`) ||
    '';

  const periodName = formatStatementPeriodName(item);

  return {
    ...item,
    accountLabelLong: item.accountLabel + labelExtra,
    downloadFileName: computePdfName(item, periodName),
  };
}

export function enrichGroupedAccountStatement(
  item: API.GroupedAccountStatement
): EnrichedGroupedAccountStatement {
  return {
    periodName: item.periodName,
    periodType: item.periodType,
    statements: (item.statements ?? []).map(enrichAccountStatement),
  };
}
